import { styled, keyframes } from "@mui/material/styles";
import { Box } from "@mui/material";

const slideInFromRight = keyframes`
    0% { transform: translateX(100%); opacity: 0; }
    100% { transform: translateX(0); opacity: 1; }
`;

const slideInFromLeft = keyframes`
    0% { transform: translateX(-100%); opacity: 0; }
    100% { transform: translateX(0); opacity: 1; }
`;

export const StepWrapper = styled(Box)(({ direction }) => ({
    width: "100%",
    maxWidth: 600,
    animation: `${direction === "right" ? slideInFromRight : slideInFromLeft} 0.6s ease`,
}));
